import React, { memo } from 'react';

import {
	useAuthAction,
	useAuthState
} from '../../contexts/AuthContext';
import { useUIState } from '../../contexts/UIContext';

import AgencyPortal from '../AgencyPortal';
import AuthPortal from '../AuthPortal';
import ManagementPortal from '../ManagementPortal';
import { ScreenLoader } from '../Loaders';

const Router = () => {
	const { user } = useAuthState();
	const { signOut } = useAuthAction();
	const { screenLoader } = useUIState();

	let portal = null;

	if ( !user ) {
		portal = <AuthPortal />;
	} else if ( user.portal.destination === 1 ) {
		// Management Routes
		portal = <ManagementPortal />;
	} else if ( user.portal.destination === 2 ) {
		// Agency Dashboard Routes
		portal = <AgencyPortal />;
	} else {
		// maybe sign them out and kick back to auth????
		portal = <p>
			This user has not been assigned to a valid portal. Please contact support.
			<span
				onClick={ signOut }
				style={ {
					textDecoration: 'underline',
					color: '#0070E0'
				} }
			>
					click here
			</span>
			to return to the login form.
		</p>;
	}

	return (
		<>
			{ portal }
			<ScreenLoader
				loading={ Boolean( screenLoader ) }
				message={ screenLoader }
			/>
		</>
	);
};

export default memo( Router );

